import React, { useState } from 'react'
import { Button, Stack, SimpleModal, Text, FormControl, Textarea, Alert } from '@/components/lib'
import api from '../../api'
import useReauthentication from '@/hooks/useReauthentication'

export default function TrialLocker ({ trial, isLocking, trigger, onComplete }) {
  const [open, setOpen] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState('')
  const [justification, setJustification] = useState('')
  const { withReauth } = useReauthentication()

  const toggleLock = () => {
    setError('')
    setLoading(true)
    withReauth(isLocking ? 'Locking the trial' : 'Unlocking the trial', (token, resolve, reject) =>
      api.trials.updateWithReauth(trial?._id, { isLocked: !trial.isLocked, lockJustification: justification }, token, resolve, reject)
    ).then(newTrial => {
      onComplete(newTrial)
      setLoading(false)
      setOpen(false)
    }).catch(err => {
      if (!err?.cancelled) setError(err.message)
      setLoading(false)
    })
  }

  return (
    <>
      {trigger
        ? React.cloneElement(trigger, { onClick: () => setOpen(true) })
        : <Button onClick={() => setOpen(true)}>{isLocking ? 'Lock trial' : 'Unlock trial'}</Button>}
      <SimpleModal
        isOpen={open} onClose={() => setOpen(false)} modalProps={{ size: 'xl' }}
        header={isLocking ? 'Lock trial' : 'Unlock trial'}
        body={
          <Stack gap={5}>
            <Text>{isLocking ? 'When the trial is locked, stages and datatypes cannot be edited.' : 'Unlocking the trial will enable the editing of stages and datatypes.'}</Text>
            <FormControl label='Justification' isRequired helperText='A brief justification or sign-off note for this action is required.'>
              <Textarea value={justification} onChange={e => setJustification(e.target.value)} />
            </FormControl>

            <Alert variant='left-accent'>Please note that trial administrators will be notified of this change.</Alert>
          </Stack>
}
        footer={
          <>
            {error && <Alert variant='left-accent' status='error'>{error}</Alert>}
            <Button onClick={e => setOpen(false)}>Cancel</Button>
            <Button isLoading={loading} colorPalette='primary' onClick={toggleLock}>{isLocking ? 'Lock trial' : 'Unlock trial'}</Button>
          </>
}
      />
    </>
  )
}
